skrilla.directive('dailyCreditCardSettlement',function() {
    return {
        templateUrl: 'directives/dailyCreditCardSettlement/dailyCreditCardSettlement.html',
        scope: {
        },
        controller: function($scope, searchService, modalService, currencyService, dateService){

            $scope.settle = function(){
                modalService.confirm("Are you sure you'd like to settle?", function(){
                    const request = {
                        ...$scope.settlement,
                        foreignAmount: currencyService.multiply($scope.settlement.foreignAmount, $scope.settlement.foreignCurrency),
                        audAmount: currencyService.multiply($scope.settlement.audAmount, 'AUD'),
                        date: dateService.getDate($scope.settlement.date, {value: "LOCAL"}),
                    }
                    searchService.post("dailyCreditCardSettlement", request, "CreditCard successfully settled").then(function(response){
                        $scope.settlement = {};
                    });
                });
            }
        }
    };
});
